import { cloneValue, sliceThreadBeforeUserTurn, sliceUiBeforeUserTurn, } from "./conversationForkService";
import { getRuntimeGlobalState } from "./conversationRuntimeService";
const estimateTokensForMessage = (message) => {
    let content = "";
    if (typeof message.content === "string") {
        content = message.content;
    }
    else if (Array.isArray(message.content)) {
        content = message.content
            .filter((part) => part.type === "text")
            .map((part) => part.text || "")
            .join(" ");
    }
    return Math.ceil(content.length / 4) + 10;
};
const estimateTokensForMessages = (messages) => {
    return messages.reduce((total, message) => total + estimateTokensForMessage(message), 0);
};
const buildFallbackTitle = (messages) => {
    const firstUserMessage = messages.find((message) => message.role === "user" && typeof message.content === "string" && message.content.trim().length > 0);
    if (!firstUserMessage) {
        return `Taskpane - ${new Date().toLocaleDateString()}`;
    }
    const compact = firstUserMessage.content.replace(/\s+/g, " ").trim();
    return compact.length <= 50 ? compact : `${compact.slice(0, 50)}...`;
};
export async function rewriteConversationFromUserTurn(conversationId, userTurnOrdinal, sourceUiMessages, options) {
    if (!conversationId) {
        throw new Error("Cannot rewrite conversation: missing conversation ID.");
    }
    if (!Number.isInteger(userTurnOrdinal) || userTurnOrdinal <= 0) {
        throw new Error("Cannot rewrite conversation: invalid user turn ordinal.");
    }
    if (!options.primaryAgentType) {
        throw new Error("Cannot rewrite conversation: missing primaryAgentType.");
    }
    const truncatedUiMessages = sliceUiBeforeUserTurn(sourceUiMessages, userTurnOrdinal);
    const globalState = getRuntimeGlobalState();
    const sourceConversation = globalState.getConversation(conversationId);
    if (!sourceConversation) {
        throw new Error(`Cannot rewrite conversation: conversation ${conversationId} not found.`);
    }
    const threadManager = sourceConversation.agentRegistry.threadManager;
    const sourcePrimaryThread = threadManager.getMostRecentThread(options.primaryAgentType, conversationId);
    if (!sourcePrimaryThread) {
        throw new Error("Cannot rewrite conversation: source primary thread not found.");
    }
    const truncatedThreadMessages = sliceThreadBeforeUserTurn(sourcePrimaryThread.messages, userTurnOrdinal);
    threadManager.deleteThreadsForConversation(conversationId);
    const rewrittenThread = {
        threadId: sourcePrimaryThread.threadId,
        agentType: sourcePrimaryThread.agentType,
        conversationId,
        documentId: sourcePrimaryThread.documentId,
        messages: cloneValue(truncatedThreadMessages),
        createdAt: sourcePrimaryThread.createdAt,
        lastActivityAt: Date.now(),
        tokenUsage: {
            used: estimateTokensForMessages(truncatedThreadMessages),
            max: sourcePrimaryThread.tokenUsage.max,
        },
    };
    threadManager.restoreThread(rewrittenThread, true);
    if (options.rebuildSearchHistoryFromMessages) {
        sourceConversation.searchHistory = options.rebuildSearchHistoryFromMessages([{ messages: rewrittenThread.messages }], sourceConversation.documentId || sourceConversation.presentationId);
    }
    const title = options.title?.trim() || buildFallbackTitle(sourceUiMessages);
    try {
        await globalState.persistConversation(conversationId, { title, status: "active" });
    }
    catch (error) {
        console.warn("[ConversationEditService] Failed to persist rewritten conversation:", error);
    }
    return {
        conversationId,
        messages: truncatedUiMessages,
    };
}
